import { Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Tabs } from "../../app/layout/Tabs";
import { unsavedTabGuard } from "../../hooks/useUnsavedGuard";

/**
 * The address master and everything derived from it (ADR 142/168/186/213).
 *
 * Four independent working surfaces, split out of one 735-line page so each can
 * be read, tested and extended alone — the zone editor lives in Zonas (ADR 403). Each
 * section names itself through its tab label, so the panels below carry their
 * explanatory note without repeating the title.
 */
export function StructureTab() {
  const { t } = useTranslation();
  return (
    <Tabs
      ariaLabel={t("warehouse.structure.aria")}
      guard={unsavedTabGuard}
      items={[
        { to: "addresses", label: t("warehouse.structure.addresses") },
        { to: "zones", label: t("warehouse.structure.zones") },
        { to: "heights", label: t("warehouse.structure.heights") },
        { to: "graph", label: t("warehouse.structure.graph") },
      ]}
    >
      <Outlet />
    </Tabs>
  );
}
